<div class="client-chips" role="group" aria-label="Filtrar pelo que vai ao cliente">
  <span class="client-chips__label">Para o cliente:</span>
  @for (chip of chips(); track chip.label) {
    <button
      type="button"
      class="client-chips__chip"
      [class.client-chips__chip--active]="chip.value === selected()"
      [attr.aria-pressed]="chip.value === selected()"
      (click)="choose(chip.value)">
      @if (chip.marker === 'private') {
        <i class="pi pi-lock client-chips__lock" aria-hidden="true"></i>
      } @else if (chip.marker) {
        <span
          [class]="'client-chips__dot client-chips__dot--' + chip.marker"
          aria-hidden="true"></span>
      }
      {{ chip.label }}
      @if (chip.count !== null) {
        <strong class="client-chips__count">{{ chip.count }}</strong>
      }
    </button>
  }
</div>
